import {
  Alert, Avatar, Chip, Stack, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography
} from '@mui/material';
import { pointsPreviousStep, saveMatchDayRequest } from '../../../actions/points';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import StepActions from './StepActions';

export default function Step5() {
  const dispatch = useAppDispatch();
  const { expandedResults, users, comment, dateTime } = useAppSelector((s) => s.points);
  const claimed = users.filter((user) => Object.values(user.penalties).some(Boolean));

  return (
    <Stack className="step5" spacing={2} alignItems="flex-start">
      <Typography variant="h6">Podsumowanie</Typography>
      <Typography variant="body2" color="text.secondary">
        {new Date(dateTime).toLocaleString('pl-PL', {
          dateStyle: 'full', timeStyle: 'short'
        })}
      </Typography>

      {/* comment.length on its own rendered a literal 0 when there was no comment. */}
      {comment.length > 0 && (
        <Alert severity="info" sx={{ width: '100%', maxWidth: 560 }}>
          <strong>Komentarz synoptyka:</strong> {comment}
        </Alert>
      )}

      <Typography variant="subtitle1">Wyniki meczów</Typography>
      <TableContainer sx={{ maxWidth: 560 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Gracz 1</TableCell>
              <TableCell align="center">Wynik</TableCell>
              <TableCell align="right">Gracz 2</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {expandedResults.map((row) => (
              <TableRow key={row._id} hover>
                <TableCell>{row.player1.name}</TableCell>
                <TableCell align="center">
                  {row.player1Score} : {row.player2Score}
                </TableCell>
                <TableCell align="right">{row.player2.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="subtitle1">Kary</Typography>
      {claimed.length === 0
        ? <Typography variant="body2" color="text.secondary">Brak kar.</Typography>
        : (
          <Stack spacing={1} sx={{ width: '100%', maxWidth: 560 }}>
            {claimed.map((user) => (
              <Stack key={user._id} direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
                <Avatar sx={{ width: 28, height: 28 }}>
                  {user.name.slice(0, 1).toUpperCase()}
                </Avatar>
                <Typography variant="body2">{user.name}</Typography>
                {Object.entries(user.penalties)
                  .filter(([, on]) => on)
                  .map(([type]) => type)
                  .sort()
                  .map((type) => <Chip key={type} size="small" color="warning" label={type} />)}
              </Stack>
            ))}
          </Stack>
        )}

      <StepActions
        onBack={() => dispatch(pointsPreviousStep())}
        onNext={() => dispatch(saveMatchDayRequest())}
        nextLabel="Wyślij"
      />
    </Stack>
  );
}
